// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ProjectsContent = registerClientReference(
    function() { throw new Error("Attempted to call ProjectsContent() from the server but ProjectsContent is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/projects/page.tsx",
    "ProjectsContent",
);
export const categoryToSlug = registerClientReference(
    function() { throw new Error("Attempted to call categoryToSlug() from the server but categoryToSlug is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/projects/page.tsx",
    "categoryToSlug",
);
export default registerClientReference(
    function() { throw new Error("Attempted to call the default export of [project]/src/app/projects/page.tsx from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/projects/page.tsx",
    "default",
);
export const slugToCategory = registerClientReference(
    function() { throw new Error("Attempted to call slugToCategory() from the server but slugToCategory is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/projects/page.tsx",
    "slugToCategory",
);
